<template>
  <div class="log-search">
    <Icon name="general.search" size="xs" class="log-search__icon" />
    <input :value="modelValue" type="text" placeholder="Search" class="log-search__input" data-testid="logs-search-input" @input="onInput" />
    <button
      v-if="modelValue.length > 0"
      type="button"
      class="log-search__clear"
      aria-label="Clear search"
      data-testid="logs-search-clear"
      @click="$emit('update:modelValue', '')"
    >
      <Icon name="general.close" size="xs" />
    </button>
  </div>
</template>

<script setup lang="ts">
import { Icon } from '@/storybook';

defineProps<{
  modelValue: string;
}>();

const emit = defineEmits<{
  'update:modelValue': [value: string];
}>();

const onInput = (event: Event) => {
  const target = event.target as HTMLInputElement;
  emit('update:modelValue', target.value);
};
</script>

<style scoped>
.log-search {
  @apply relative flex items-center px-4 sm:px-5 py-2;
}

.log-search__icon {
  @apply absolute left-7 sm:left-8 text-zinc-400 dark:text-zinc-500 pointer-events-none;
}

.log-search__input {
  @apply w-full pl-7 pr-7 py-2.5 text-sm rounded-10 bg-white dark:bg-zinc-900 border border-slate-300 dark:border-zinc-700 text-zinc-800 dark:text-zinc-100 placeholder-slate-400 dark:placeholder-zinc-500 focus:outline-none focus:ring-2 focus:ring-blue-500/50 focus:border-blue-400 dark:focus:border-blue-500;
}

.log-search__clear {
  @apply absolute right-7 sm:right-8 p-0.5 rounded text-zinc-400 dark:text-zinc-500 hover:text-zinc-700 dark:hover:text-zinc-200 cursor-pointer;
}
</style>
